import React from 'react';
import Button from '../Button';
import { LinkComponent } from '../Link';
import { TextP } from '../Text';
import * as Styled from './styles';

type IEditFooterBar = {
  urlPath?: string;
  altUrlPath?: string;
  showDelete?: boolean;
  showNew?: boolean;
  showEdit?: boolean;
  showSave?: boolean;
  showSaveDraft?: boolean;
  showComplete?: boolean;
  showFunctionalDelete?: boolean;
  disableTestEmail?: boolean;
  disableAll?: boolean;
  handleSubmit: (type: string) => void;
  emailActions?: {
    sendTestEmail: () => void;
    sendBulkEmail?: () => void;
  };
  error?: any;
  loading?: boolean;
};

const EditFooterBar = ({
  urlPath,
  altUrlPath = '',
  showDelete = true,
  showNew = true,
  showEdit = true,
  showSave = true,
  showComplete,
  showSaveDraft,
  showFunctionalDelete = false,
  disableTestEmail = false,
  disableAll,
  handleSubmit,
  emailActions,
  error,
  loading,
}: IEditFooterBar) => {
  const [isSaving, setIsSaving] = React.useState(false);

  const handleSave = async (type: string) => {
    setIsSaving(true);
    await handleSubmit(type);
    setIsSaving(false);
  };

  if (loading) {
    return null;
  }

  return (
    <>
      <div
        style={{
          color: 'rgb(186, 33, 33)',
          marginLeft: '180px',
          marginTop: '10px',
          fontFamily:
            'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
          fontSize: '14px',
          fontWeight: 700,
        }}
      >
        {Object.keys(error || {}).length > 0 && 'fix the errors above to continue'}
      </div>
      <Styled.ButtonsContainerWrapper>
        <div>
          {/* for newsletter the url path needs to be different */}
          {showDelete && (
            <LinkComponent url={altUrlPath || `/${urlPath}/delete`} theme="warning">
              <div>
                <TextP>Delete</TextP>
              </div>
            </LinkComponent>
          )}
          {showFunctionalDelete && (
            <Button onClick={() => handleSubmit('delete')} theme="warning" disabled={disableAll}>
              <p>Delete</p>
            </Button>
          )}
        </div>
        <Styled.FlexBoxStyled>
          {showNew && (
            <Button onClick={() => handleSubmit('add')} theme="secondary" disabled={disableAll}>
              <p>Save and add another</p>
            </Button>
          )}

          {emailActions?.sendTestEmail && (
            <Styled.ButtonWrapper>
              <Button
                onClick={() => emailActions?.sendTestEmail()}
                theme="secondary"
                disabled={disableTestEmail || isSaving || disableAll}
              >
                <p>Send test email</p>
              </Button>
            </Styled.ButtonWrapper>
          )}

          {/* change emailActions.sendBulkEmail!() to emailActions?.sendBulkEmail?.() once tested existing code */}
          {emailActions?.sendBulkEmail && (
            <Styled.ButtonWrapper>
              <Button
                onClick={() => emailActions.sendBulkEmail!()}
                disabled={isSaving || disableAll}
              >
                <p>Send bulk email</p>
              </Button>
            </Styled.ButtonWrapper>
          )}

          {showEdit && (
            <Styled.ButtonWrapper>
              <Button
                onClick={() => handleSubmit('edit')}
                theme="secondary"
                disabled={isSaving || disableAll}
              >
                <p>Save and continue editing</p>
              </Button>
            </Styled.ButtonWrapper>
          )}
          {showSave && (
            <Styled.ButtonWrapper>
              <Button onClick={() => handleSubmit('save')} disabled={isSaving || disableAll}>
                <p>SAVE</p>
              </Button>
            </Styled.ButtonWrapper>
          )}
          {showSaveDraft && (
            <Styled.ButtonWrapper>
              <Button onClick={() => handleSave('draft')} disabled={isSaving || disableAll}>
                <p>Save as Draft</p>
              </Button>
            </Styled.ButtonWrapper>
          )}
          {showComplete && (
            <Styled.ButtonWrapper>
              <Button onClick={() => handleSave('complete')} disabled={isSaving || disableAll}>
                <p>Complete ( Schedule to send )</p>
              </Button>
            </Styled.ButtonWrapper>
          )}
        </Styled.FlexBoxStyled>
      </Styled.ButtonsContainerWrapper>
    </>
  );
};

export default EditFooterBar;
